const report = [
  {
    path: '/report/doctor',
    name: 'report_doctor',
    component: () => import( '@/pages/report/doctor'),
    meta: {keepAlive: true, name: '首页'},
  },

  {
    path: '/report/total',
    name: 'report_total',
    component: () => import( '@/pages/report/total'),
    meta: {keepAlive: true, name: '首页'},
  },
  {
    path: '/report/department',
    name: 'report_department',
    component: () => import( '@/pages/report/department'),
    meta: {keepAlive: true, name: '首页'},
  },
]

export default report



// WEBPACK FOOTER //
// ./src/router/modules/report.js